import { logout } from "@/stores/authSlice";
import { store } from "@/stores/store";
import { getToken } from "@/utils/helper";
import axios, { HttpStatusCode } from "axios";

const pendingRequests = new Map();

export const API_URL = import.meta.env.MODE === "production"
    ? import.meta.env.VITE_API_PRO
    : import.meta.env.VITE_API_DEV;

const API_KEY = import.meta.env.VITE_API_KEY;

const BaseService = axios.create({
    baseURL: `${API_URL}/api`,
    timeout: 60000,
    headers: {
        "x-api-key": API_KEY,
    }
});

BaseService.interceptors.request.use(function (config) {
    const controller = new AbortController();
    const accessToken = getToken();
    config.signal = controller.signal;
    if (accessToken) config.headers["Authorization"] = `Bearer ${accessToken}`;
    pendingRequests.set(config.url, controller);
    return config;
}, function (error) {
    return Promise.reject(error);
});

BaseService.interceptors.response.use(function (response) {
    pendingRequests.delete(response.config.url);
    if (response && response.data && [HttpStatusCode.Unauthorized].includes(response.data.statusCode)) {
        store.dispatch(logout())
    }

    return response;

}, function (error) {
    // const { response } = error
    pendingRequests.delete(error.config?.url);

    return Promise.reject(error);
});

export default BaseService;